import { createSlice } from "@reduxjs/toolkit";

function mapStoredToUserss(u) {
  if (!u || typeof u !== "object") return null;
  const role = u.is_white_team
    ? "WHITE TEAM"
    : u.user_role || u.team || "";
  return {
    user_id: u.id ?? u.user_id,
    user_full_name: u.full_name || u.username || "",
    user_avatar: u.avatar?.image_url || u.user_avatar || "",
    is_admin: Boolean(u.is_staff ?? u.is_admin),
    user_role: typeof role === "string" ? role : "",
  };
}

export function readUserssFromStorage() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem("cyberrange_user");
    if (!raw) return null;
    return mapStoredToUserss(JSON.parse(raw));
  } catch {
    return null;
  }
}

const initialState = {
  userss: readUserssFromStorage(),
  loading: false,
  error: null,
};

const sessionUserSlice = createSlice({
  name: "sessionUser",
  initialState,
  reducers: {
    syncUserFromStorage: (state) => {
      state.userss = readUserssFromStorage();
    },
    setUserLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUserError: (state, action) => {
      state.error = action.payload;
    },
    clearSessionUser: (state) => {
      state.userss = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  syncUserFromStorage,
  setUserLoading,
  setUserError,
  clearSessionUser,
} = sessionUserSlice.actions;

export default sessionUserSlice.reducer;
